<template>
  <q-page class="q-pa-md bg-grey-2">
    <div class="row q-col-gutter-md">
      <div class="col-12">
        <q-card class="bg-primary text-white">
          <q-card-section>
            <div class="text-h4">Панель управления</div>
          </q-card-section>
        </q-card>
      </div>

      <div class="col-12 col-md-6 col-lg-4">
        <q-card class="dashboard-card">
          <q-card-section>
            <div class="row items-center no-wrap">
              <div class="col">
                <div class="text-h6">Организации</div>
                <div class="text-subtitle2">Всего: {{ totalOrganizations }}</div>
              </div>
              <div class="col-auto">
                <q-icon name="business" size="3.5em" color="primary" />
              </div>
            </div>
          </q-card-section>
          <q-separator />
          <q-card-section>
            <div class="row q-col-gutter-sm">
              <div class="col-6">
                <q-circular-progress :value="activeOrganizationsPercentage" size="100px" :thickness="0.22"
                  color="positive" track-color="grey-3" class="q-ma-md">
                  <div class="text-center">
                    <div class="text-h6">{{ activeOrganizationsPercentage }}%</div>
                    <div class="text-caption">Активных</div>
                  </div>
                </q-circular-progress>
              </div>
              <div class="col-6">
                <div class="text-h6 q-mt-sm">{{ activeOrganizations }}</div>
                <div class="text-caption">Активных</div>
                <div class="text-h6 q-mt-md">{{ inactiveOrganizations }}</div>
                <div class="text-caption">Неактивных</div>
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>

      <!-- Balance Card -->
      <div class="col-12 col-md-6 col-lg-4">
        <q-card class="dashboard-card">
          <q-card-section>
            <div class="row items-center no-wrap">
              <div class="col">
                <div class="text-h6">Баланс</div>
                <div class="text-h4">{{ formatCurrency(balance) }}</div>
              </div>
              <div class="col-auto">
                <q-icon name="account_balance_wallet" size="3.5em" color="primary" />
              </div>
            </div>
          </q-card-section>
          <q-separator />
          <q-card-section>
            <div class="row items-center no-wrap">
              <div class="col">
                <div class="text-h6">Списаний в день</div>
                <div class="text-h4">{{ formatCurrency(dailyIncome) }}</div>
              </div>
              <div class="col-auto">
                <q-icon name="trending_up" size="3.5em" color="positive" />
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>

      <div class="col-12 col-md-6 col-lg-3">
      </div>

        <!-- Active Users Card -->
        <div class="col-12 col-md-6 col-lg-4">
          <q-card class="dashboard-card">
            <q-card-section>
              <div class="row items-center no-wrap">
                <div class="col">
                  <div class="text-h6">Активных пользователей</div>
                  <div class="text-h4">{{ activeUsers }}</div>
                </div>
                <div class="col-auto">
                  <q-icon name="people" size="3.5em" color="primary" />
                </div>
              </div>
            </q-card-section>
          </q-card>
        </div>
      </div>
  </q-page>
</template>

<script>

import { apiUrl } from "../config";
import axios from "axios";
import { ref, computed } from 'vue'

export default {
  name: "manager_org",
  data() {
    axios
      .post(apiUrl + '/admin/stats/', {}, { auth: this.$store.state.credentials })
      .then((response) => {
        console.log(response)
        if (response.error !== undefined) {
          this.$q.notify({
            color: 'negative',
            message: 'Неизвестная ошибка',
            icon: 'error'
          })
        } else {
          this.activeOrganizations = response.data.active_organizations
          this.inactiveOrganizations = response.data.inactive_organizations
          this.balance = response.data.balance
          this.dailyIncome = response.data.daily_income
          this.activeUsers = response.data.active_users_count
        }
      })
      .catch((error) => {
        console.log(error)
        this.$q.notify({
          color: 'negative',
          message: 'Неизвестная ошибка',
          icon: 'error'
        })
      })
    return {
      activeOrganizations: ref(0),
      inactiveOrganizations: ref(0),
      balance: ref(0),
      dailyIncome: ref(0),
      activeUsers: ref(0),
      totalOrganizations: computed(() => this.activeOrganizations + this.inactiveOrganizations),
      activeOrganizationsPercentage: computed(() =>
        Math.round((this.activeOrganizations / this.totalOrganizations) * 100)
      ),
      activeUsersChange: ref('+50')
    }
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: 'RUB',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value)
    }
  }
}

</script>

<style scoped>
.dashboard-card {
  height: 100%;
}
</style>
